import React from "react";
import "../styles/trinkets.css";
import "../styles/slider.css";
import Web3 from 'web3'

const jabba_forms_abi = [ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "approved", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" } ], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "MAX_JABBAS", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "METADATA_PROVENANCE_HASH", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" } ], "name": "balanceOf", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "baseURI", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "calculatePrice", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_id", "type": "uint256" } ], "name": "calculatePriceTest", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address[]", "name": "userAddresses", "type": "address[]" } ], "name": "communityTRINKET", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "getApproved", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "hasSaleStarted", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" } ], "name": "isApprovedForAll", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "numJabbas", "type": "uint256" } ], "name": "mintTRINKET", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "ownerOf", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "pauseDrop", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "bytes", "name": "_data", "type": "bytes" } ], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" } ], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "string", "name": "baseURI", "type": "string" } ], "name": "setBaseURI", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "string", "name": "_hash", "type": "string" } ], "name": "setProvenanceHash", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "startDrop", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "bytes4", "name": "interfaceId", "type": "bytes4" } ], "name": "supportsInterface", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "index", "type": "uint256" } ], "name": "tokenByIndex", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "index", "type": "uint256" } ], "name": "tokenOfOwnerByIndex", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "tokenURI", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_owner", "type": "address" } ], "name": "tokensOfOwner", "outputs": [ { "internalType": "uint256[]", "name": "", "type": "uint256[]" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "transferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "withdrawAll", "outputs": [], "stateMutability": "payable", "type": "function" } ]
// rinkeby
//const jabba_forms_contract_address = "0xa0d8c43465f1Aa6F361ef572F79FBbbfD387DA0f"

// mainnet
const jabba_forms_contract_address = "0x0B0f6BC78Ea9FB88dD58fDfe4C03F0c78721f649"

class TRINKETS extends React.Component {



    constructor() {
      super();
      this.state = {
        address: "No wallet connected",
        connected: false,
        signedIn: false,
        network: null,
        currPrice: 0,
        priceInputValue: "0",
        priceInput: {
          0: "1",
          1: "2",
          2: "3",
          3: "4",
          4: "5",
          5: "6",
          6: "7",
          7: "8",
          8: "9",
          9: "10",
          10: "11",
          11: "12",
          12: "13",
          13: "14",
          14: "15",
          15: "16",
          16: "17",
          17: "18",
          18: "19",
          19: "20",
          20: "21",
          21: "22",
          22: "23",
          23: "24",
          24: "25",
          25: "26",
          26: "27",
          27: "28",
          28: "29",
          29: "30",
          30: "31",
          31: "32",
          32: "33",
          33: "34",
          34: "35",
          35: "36",
          36: "37",
          37: "38",
          38: "39",
          39: "40",
          40: "41",
          41: "42",
          42: "43",
          43: "44",
          44: "45",
          45: "46",
          46: "47",
          47: "48",
        },
      };
    }

    async componentWillMount(){
      await this.ConnectMetamask()
      //await this.DisplayPurchasePrice()
      var currPrice = await this.GetPurchasePrice()
      this.setState({currPrice: currPrice})
    }

    GetNetwork() {
      return new Promise(resolve => {
        window.web3.eth.net.getNetworkType().then(response => resolve(response))
      })
    }

    async ConnectMetamask(){
      this.setState({connected:false, signedIn: false});

      if (typeof window.web3 !== 'undefined') {
        window.web3 = new Web3(window.ethereum);
        var net = await this.GetNetwork();
        if(net != "main"){
          alert("You are not on ethereum mainnet!")
          return;
        }
        this.setState({connected: true, network: net})
      } else {
        this.setState({connected: false})
        return;
      }

      if (window.ethereum) {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        if(window.ethereum.selectedAddress){
          this.setState({signedIn: true});
        }
      } else {
        this.setState({signedIn: false});
      }
    }

    async ConnectAndUpdatePage(){
      if(!this.state.connected){
        alert("No wallet available");
        return;
      }

      await window.ethereum.request({ method: 'eth_requestAccounts' });

      if(window.ethereum.selectedAddress){
        this.setState({signedIn: true});
      }

      var currPrice = await this.GetPurchasePrice()
      this.setState({currPrice: currPrice})

    }

    async GetPurchasePrice(){
      if(this.state.connected){
        const jabbaContract = new window.web3.eth.Contract(jabba_forms_abi, jabba_forms_contract_address)
        const currPrice = await jabbaContract.methods.calculatePrice().call()
        return currPrice
      }
      return 0;
    }

    CreatePurchasePrice(){

      if(!this.state.signedIn){
        return (
          <button onClick={this.ConnectAndUpdatePage.bind(this)}> <img class="connect-wallet-52Wjwg" src="img/connect-wallet-1@2x.png"/> </button>
        )
      }

      if(this.state.currPrice == 80000000000000000){
        return (
          <img class="x08-eth-1-52Wjwg" src="img/08eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 140000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/14eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 250000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/25eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 330000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/33eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 400000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/40eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 500000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/50eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 600000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/60eth-1@2x.png" />
        )
      }
      else if(this.state.currPrice == 1000000000000000000){
        return(
          <img class="x08-eth-1-52Wjwg" src="img/1eth-1@2x.png" />
        )
      }

    }

    async PurchaseJabba(){
      this.ConnectMetamask()

      if(!this.state.signedIn){
        alert("wallet not connected")
        return;
      }

      const jabbaContract = new window.web3.eth.Contract(jabba_forms_abi, jabba_forms_contract_address)
      const currPrice = await jabbaContract.methods.calculatePrice().call()

      const numJabbasForPurchase = parseInt(this.state.priceInputValue) + 1
      const totalPrice = currPrice * numJabbasForPurchase

      const transactionParameters = {
        to: jabba_forms_contract_address,
        from: window.ethereum.selectedAddress,
        value: totalPrice.toString(),
      };

      var res = await jabbaContract.methods.mintTRINKET(numJabbasForPurchase).send(transactionParameters)

    }

    slider = React.createRef();
    sliderValue = React.createRef();

    componentDidMount() {
      this.slider.current.setAttribute("min", 0);
      this.slider.current.setAttribute(
        "max",
        Object.keys(this.state.priceInput).length - 1
      );
      this.thumbSize = parseInt(
        window.getComputedStyle(this.sliderValue.current),
        0
      );
    }

    handlePricingSlide = (e) => {
      this.setState({ priceInputValue: e.target.value });
    };

    getPricingData = (obj, pos) => {
      return pos !== undefined
        ? obj[this.state.priceInputValue][pos]
        : obj[this.state.priceInputValue];
    };



    render(){
        return (
            <div class="container-center-horizontal">
            <div class="purchase screen">
              <div class="flx-ecol-C61RwL">
                <div class="overlap-group1-0xy0vn">
                <img class="trinkhead" src="img/trinketshead.png" />
                <div class="spacemono-normal-black-15px">
                <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                <br></br><br></br><br></br><br></br><br></br><br></br>
                  J48BATRINKETS: the newest edition to the GROTTO LABS ecosystem. With the entire collection available for 0.033ETH, you can afford to join GROTTO LABS archeological team in the dig for the rarest trinkets in the series. <br/>
                  <br/>
                  J48BATRINKETS mints in random sequence with super rare subtypes and redeemable merchandise tokens plus 2 usdt grand prizes to be minted! <br/>
                </div>

                </div>
                
                  <div class="flex-col-IMpwyX">
                  {/* START SLIDER */}
                    <div className="slider-wrapper">
                    <div className="slider-input">
                    {/*<span>SLIDER GOES HERE</span>*/}
                    <div className="slider-output-wrapper" class="num-purchase-jabbas spacemono-normal-black-15px">
                    <div ref={this.sliderValue} className="slider-value" style={{fontWeight: "bold"}}>
                    <div></div><br></br><br></br><br></br><br></br><div></div><br></br><br></br><br></br><br></br>
                    <a href="https://opensea.io/collection/j48batrinkets">TRINKETS ARE SOLD OUT! CLICK TO BUY SECONDARY ON OPENSEA!</a>
                    
                    </div><img class="mintbutton" src="img/trinketssold.jpeg" />
                    <br></br><br></br>
                    </div>

                        <input
                          type="range"
                          ref={this.slider}
                          defaultValue={this.state.priceInputValue}
                          onChange={this.handlePricingSlide}
                        />

                    </div>

                                      </div>
                  {/* END SLIDER */}
                
                  </div>
                


                <div class="flex-col-0xy0vn">
            
            <div class="flex-row-xpmbvu">
              <div class="overlap-group-fKmFVR">
                
                <div class="flex-col-H5vPvf">
                <a href="https://discord.gg/y4ZKkz9CV2" target="_blank"><img class="asset-35-discord-1-ASQbkE" src="img/asset-35discord-1@2x.png" /></a>
                  <div class="frame-1-ASQbkE"></div>
                </div>
                <img class="asset-26-j48-messy-1-H5vPvf" src="img/asset-26j48messy-1-1@2x.png" />
                <img class="asset-41-grottolab1-1-H5vPvf" src="img/asset-41grottolab1-1@2x.png" />
                <img class="grotto-labs-logo-5-H5vPvf" src="img/grotto-labs-logo-6@2x.png" />
              </div>
              <a href="https://twitter.com/j48baforms" target="_blank"><img class="asset-34-twitter-1-fKmFVR" src="img/asset-34twitter-1@2x.png" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
        )
    }

};
export default TRINKETS;
